import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IResult } from 'app/shared/models/result.model';
import { IDtoPayrollEmployee } from 'app/shared/models/employee/dto-payroll-employee.model';
import { IDtoEmployeeFilter } from 'app/shared/models/employee/dto-employee-filter.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IStudy } from 'app/shared/models/recruitment/study.model';
import { IDtoEmployeeBasicData } from 'app/shared/models/employee/dto-employee-basic-data.model';
import { IDtoEmployeePaymentData } from 'app/shared/models/employee/dto-employee-payment-data.model';
import { IDtoPayrollEmployeeDetail } from 'app/shared/models/employee/dto-payroll-employee-detail.model';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IDtoEmployeeShippingAddress } from 'app/shared/models/employee/dto-employee-shipping-address.model';
import { IDtoJobCandidateBasic } from '../../shared/models/employee/dto-jobcandidate-basic.model';

@Injectable()
export class EmployeeService {
    private payrollUrl = '';
    private recruitmentUrl = '';
    private requestUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
            this.payrollUrl = this.configurationService.serverSettings.payrollUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
                this.requestUrl = this.configurationService.serverSettings.requestUrl;
                this.payrollUrl = this.configurationService.serverSettings.payrollUrl;
            });
        }
    }
    public getListPayrollEmployees(values: IDtoEmployeeFilter): Observable<IDtoPayrollEmployee[]> {
        const url =`${this.recruitmentUrl}api/Employees/getListPayrollEmployees/`;
        return this.service.post(url, values).pipe(map((response: any) => {
            return response;
        }));
    }
    public getEmployeeDataPayrollById(employeeId: number): Observable<IResult> {
        const url = this.recruitmentUrl + 'api/Employees/getEmployeeDataPayrollById?employeeId=' + employeeId;
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getCatalogOfficeEmployeesActives(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/Employees/getCatalogOfficeEmployeesActives';
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getCatalogBanks(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/Banks/getCatalogBanks';
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getCatalogTypesSalary(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/TypesSalary/getCatalogTypesSalary';
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getCatalogMethodPayments(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/MethodPayments/getCatalogMethodPayments';
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getCatalogSalaryZones(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/SalaryZones/getCatalogSalaryZones';
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getCatalogFamilyMedicalUnits(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/FamilyMedicalUnits/getCatalogFamilyMedicalUnits';
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getCatalogAccountingSegments(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/AccountingSegments/getCatalogAccountingSegments';
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getCatalogBenefitCategories(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/BenefitCategories/getCatalogBenefitCategories';
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getBusinessPhone(uKey: string): Observable<string> {
        const url =`${this.payrollUrl}api/Employees/getBusinessPhone?uKey=${uKey}`;
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getCatalogSchoolLevels(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/SchoolLevels/getCatalogSchoolLevels';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogEducationLevels(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/LevelsEducation/getCatalogEducationLevels';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogDocumentsReceived(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/DocumentsReceived/getCatalogDocumentsReceived';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public processEmployeeStudy(data: IStudy): Observable<IResult> {
        let url = this.recruitmentUrl + 'api/jobCandidateLevelEducation/';
        if (data.id === undefined || data.id === null) {
            return this.service.post(url, data).pipe(map((response: any) => {
                return response;
            }));
        } else {
            return this.service.putWithId(url, data).pipe(map((response: any) => {
                return response;
            }));
        }
    }
    public processEmployeeBasicData(data: IDtoEmployeeBasicData): Observable<IResult> {
        let url = this.recruitmentUrl + 'api/EmployeeBasicData/';
        if (data.id === undefined || data.id === null) {
            return this.service.post(url, data).pipe(map((response: any) => {
                return response;
            }));
        } else {
            return this.service.putWithId(url, data).pipe(map((response: any) => {
                return response;
            }));
        }
    }
    public processEmployeePaymentData(data: IDtoEmployeePaymentData): Observable<IResult> {
        let url = this.recruitmentUrl + 'api/EmployeePaymentData/';
        if (data.id === undefined || data.id === null) {
            return this.service.post(url, data).pipe(map((response: any) => {
                return response;
            }));
        } else {
            return this.service.putWithId(url, data).pipe(map((response: any) => {
                return response;
            }));
        }
    }
    public updateEmployeePersonalData(data: IDtoPayrollEmployeeDetail): Observable<IResult> {
        let url = this.recruitmentUrl + 'api/Employees/updateEmployeePersonalData';
        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateEmployeeGeneralData(data: IDtoPayrollEmployeeDetail): Observable<IResult> {
        let url = this.recruitmentUrl + 'api/Employees/updateEmployeeGeneralData';
        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getEmployeeSalaryHistoriesbyEmployeeId(employeeId: number): Observable<IResult> {
        const url =`${this.recruitmentUrl}api/EmployeeSalaryHistories/getEmployeeSalaryHistoriesbyEmployeeId?employeeId=${employeeId}`;
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public downloadFileEmployeeSalaryUpdate(id: number): Observable<IResult> {

        const url = `${this.recruitmentUrl}api/EmployeeSalaryHistories/getFileEmployeeSalaryUpdateById?id=${id}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getListEmployeesByIds(ids: number[]): Observable<IDtoEmployee[]> {
        let url = this.recruitmentUrl + 'api/Employees/getListActiveEmployeesByIds';
        return this.service.post(url, ids).pipe(map((response: any) => {
            return response;
        }));
    }
    public getListActiveAndDismissalEmployeesByBossId(id:string): Observable<IDtoEmployee[]> {
        const url = `${this.recruitmentUrl}api/Employees/getListActiveAndDismissalEmployeesByBossId?id=${id}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateEmployeeShippingAddress(dto: IDtoEmployeeShippingAddress): Observable<IResult> {
        let url = this.recruitmentUrl + 'api/EmployeeShippingAddress/UpdateEmployeeShippingAddress';
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getEmployeeShippingAddress(personalNumber: string): Observable<IDtoEmployeeShippingAddress> {

        const url = `${this.recruitmentUrl}api/EmployeeShippingAddress/GetEmployeeShippingAddress?personalNumber=${personalNumber}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getListDismissalEmployeesByBossId (init: Date, end: Date): Observable<IDtoEmployee[]> {
        const url = `${this.recruitmentUrl}api/Employees/getListDismissalEmployeesByBossId?init=${init}&end=${end}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getEmployeeDataDismissalById(id: number): Observable<IDtoEmployee> {
        const url = `${this.requestUrl}api/Liquidations/getEmployeeDataDismissalById?requisitionId=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getEmployeeDataDismissalByEmployeeIdAndRequisitionId(employeeId: number, requisitionId: number): Observable<IDtoEmployee> {
        const url = `${this.requestUrl}api/Liquidations/getEmployeeDataDismissalByEmployeeIdAndRequisitionId?employeeId=${employeeId}&requisitionId=${requisitionId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getEmployee(employeeId: number): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/Employees/getEmployee?employeeId=${employeeId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getEmployeeTaxDataActive(employeeId: number): Observable<IResult> {
        const url =`${this.recruitmentUrl}api/Employees/getEmployeeTaxDataActive?employeeId=${employeeId}`;
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
      public getEmployeeShippingAddressByUKey(uKey: string): Observable<IDtoEmployeeShippingAddress> {
        const url = `${this.recruitmentUrl}api/EmployeeShippingAddress/GetEmployeeShippingAddressByUKey?uKey=${uKey}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateEmployeeEmailAndPersonalNumber(data: IDtoJobCandidateBasic): Observable<IResult> {
        let url = this.recruitmentUrl + 'api/Employees/updateEmployeeEmailAndPersonalNumber';
        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getEmployeeDataByBankAccount(bankAccount: string, employeeId: number): Observable<IResult> {
      const url =`${this.recruitmentUrl}api/Employees/getEmployeeDataByBankAccount?bankAccount=${bankAccount}&employeeId=${employeeId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getBasicEmployeeData(employeeId: number): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/Employees/getBasicEmployeeData?employeeId=${employeeId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
}
